export const MIME_TYPES = ['image/jpeg', 'image/png'];

export const areFilesAllowed = (files: File[], allowedTypes: string[]) =>
  files.every(file => allowedTypes.includes(file.type));
